// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileContent.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { propTypes as ObservablePropTypes } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import classnames from 'classnames';
import BlankDashboardTileContent from './BlankTile/Izenda.BlankDashboardTileContent';
import DashboardTileBody from './Izenda.DashboardTileBody';
import AppContext from 'share/enhancers/Izenda.AppContext';
import LoadingIndicator from 'share/components/controls/Izenda.LoadingIndicator';
import NoPermissionPartTile from 'modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.NoPermissionPartTile';
import { isNil } from 'lodash/fp';

class DashboardTileContent extends Component {
  static displayName = 'DashboardTileContent';

  static propTypes = {
    store: ObservablePropTypes.observableObject.isRequired,
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    dashboardDetail: ObservablePropTypes.observableObject.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      fulfilledData: false
    };

    const { store, dashboardPart } = props;
    store.loadDashboardPart(dashboardPart, true).then(() => {
      this.setState({ fulfilledData: true });
    });
  }

  shouldComponentUpdate(nextProps: any, nextState: any) {
    if (this.props.finishedRender !== nextState.finishedRender) {
      return true;
    }

    if (this.state.fulfilledData === nextState.fulfilledData) {
      return false;
    }
    return true;
  }

  render() {
    const { localization, dashboardDetail, dashboardPart, store, printingMode, finishedRender, cellWidth } = this.props;

    const disableViewReport = dashboardPart.disableViewReport;
    const type = dashboardPart.type;
    const dashboardTileBodyClass = classnames(
      'izenda-DashboardTile-Content-Body',
      'u_noPaddingAll u_noMarginAll',
      'izenda-DashboardTile-Content-Body-fixed',
      {
        'u_table u_fullSize': disableViewReport
      }
    );
    const style = printingMode ? { position: 'relative' } : {};

    const tileBody = (
      <div className={dashboardTileBodyClass} style={style}>
        {!disableViewReport ? (
          <DashboardTileBody
            dashboardPart={dashboardPart}
            viewMode
            store={store}
            printingMode={printingMode}
            fulfilledData={this.state.fulfilledData}
            finishedRender={finishedRender}
            cellWidth={cellWidth}
          />
        ) : (
          <NoPermissionPartTile finishedRender={finishedRender} />
        )}
      </div>
    );

    const blankBody = (
      <div className={dashboardTileBodyClass} style={style}>
        <BlankDashboardTileContent
          cellWidth={cellWidth}
          dashboardPart={dashboardPart}
          finishedRender={finishedRender}
        />
      </div>
    );

    const body = isNil(type) ? blankBody : tileBody;
    const dashboardTileClass = classnames('izenda-DashboardTile u_noPaddingAll u_noMarginAll', {
      'u_fullSize ': disableViewReport
    });

    const dashboardTileContentClass = classnames(
      'izenda-DashboardTile-Content u-posRelative u_noPaddingAll u_noMarginAll',
      {
        'u_fullSize ': disableViewReport
      }
    );

    return (
      <div className={dashboardTileClass}>
        <div className={dashboardTileContentClass}>
          {body}
          <LoadingIndicator />
        </div>
      </div>
    );
  }
}

const tileLoader = {};
export default connect({
  context: {
    childContextTypes: AppContext.loaderShape,
    getChildContext: function({ dashboardPart }) {
      if (!tileLoader[dashboardPart.id]) {
        tileLoader[dashboardPart.id] = AppContext.createLoaderContext();
      }
      return tileLoader[dashboardPart.id];
    }
  }
})(DashboardTileContent);



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.DashboardTileContent.js